export default __webpack_public_path__ + "static/media/Letters2_00.58683a15.png";